export const METRIC_DATA_ADMIN_GET_LIST_INIT = 'METRIC_DATA_ADMIN_GET_LIST_INIT';
export const METRIC_DATA_ADMIN_GET_LIST_SUCCESS = 'METRIC_DATA_ADMIN_GET_LIST_SUCCESS';
export const METRIC_DATA_ADMIN_GET_LIST_FAILURE = 'METRIC_DATA_ADMIN_GET_LIST_FAILURE';

export const METRIC_DATA_ADMIN_GET_METRICS_LIST_INIT = 'METRIC_DATA_ADMIN_GET_METRICS_LIST_INIT';
export const METRIC_DATA_ADMIN_GET_METRICS_LIST_SUCCESS = 'METRIC_DATA_ADMIN_GET_METRICS_LIST_SUCCESS';
export const METRIC_DATA_ADMIN_GET_METRICS_LIST_FAILURE = 'METRIC_DATA_ADMIN_GET_METRICS_LIST_FAILURE';

export const METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT = 'METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT';
export const METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS = 'METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS';
export const METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE = 'METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE';

export const METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_INIT = 'METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_INIT';
export const METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS = 'METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS';
export const METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE = 'METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE';

export const METRIC_DATA_ADMIN_IMPORT_INIT = 'METRIC_DATA_ADMIN_IMPORT_INIT';
export const METRIC_DATA_ADMIN_IMPORT_SUCCESS = 'METRIC_DATA_ADMIN_IMPORT_SUCCESS';
export const METRIC_DATA_ADMIN_IMPORT_FAILURE = 'METRIC_DATA_ADMIN_IMPORT_FAILURE';
export const METRIC_DATA_ADMIN_IMPORT_RESET = 'METRIC_DATA_ADMIN_IMPORT_RESET';

export const METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_INIT = 'METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_INIT';
export const METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS = 'METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS';
export const METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_FAILURE = 'METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_FAILURE';

export const METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_INIT = 'METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_INIT';
export const METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_SUCCESS = 'METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_SUCCESS';
export const METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_FAILURE = 'METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_FAILURE';

export const METRIC_DATA_ADMIN_GET_GROUPS_INIT = 'METRIC_DATA_ADMIN_GET_GROUPS_INIT';
export const METRIC_DATA_ADMIN_GET_GROUPS_SUCCESS = 'METRIC_DATA_ADMIN_GET_GROUPS_SUCCESS';
export const METRIC_DATA_ADMIN_GET_GROUPS_FAILURE = 'METRIC_DATA_ADMIN_GET_GROUPS_FAILURE';

export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_INIT = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_INIT';
export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_SUCCESS = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_SUCCESS';
export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_FAILURE = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_FAILURE';

export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_INIT = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_INIT';
export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_SUCCESS = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_SUCCESS';
export const METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_FAILURE = 'METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_FAILURE';

export const METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_INIT = 'METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_INIT';
export const METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_SUCCESS = 'METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_SUCCESS';
export const METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_FAILURE = 'METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_FAILURE';

export const METRIC_DATA_ADMIN_SAVE_INIT = 'METRIC_DATA_ADMIN_SAVE_INIT';
export const METRIC_DATA_ADMIN_SAVE_SUCCESS = 'METRIC_DATA_ADMIN_SAVE_SUCCESS';
export const METRIC_DATA_ADMIN_SAVE_FAILURE = 'METRIC_DATA_ADMIN_SAVE_FAILURE';
export const METRIC_DATA_ADMIN_SET_SAVE_DATA_BY_KEY = 'METRIC_DATA_ADMIN_SET_SAVE_DATA_BY_KEY';
export const METRIC_DATA_ADMIN_SAVE_RESET = 'METRIC_DATA_ADMIN_SAVE_RESET';
export const METRIC_DATA_ADMIN_DELETE_PREPARE_INIT = 'METRIC_DATA_ADMIN_DELETE_PREPARE_INIT';
export const METRIC_DATA_ADMIN_DELETE_INIT = 'METRIC_DATA_ADMIN_DELETE_INIT';
export const METRIC_DATA_ADMIN_DELETE_SUCCESS = 'METRIC_DATA_ADMIN_DELETE_SUCCESS';
export const METRIC_DATA_ADMIN_DELETE_FAILURE = 'METRIC_DATA_ADMIN_DELETE_FAILURE';

export const METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT = 'METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT';
export const METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS = 'METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS';
export const METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE = 'METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE';

export const METRIC_DATA_ADMIN_GET_PERIODS_LIST_INIT = 'METRIC_DATA_ADMIN_GET_PERIODS_LIST_INIT';
export const METRIC_DATA_ADMIN_GET_PERIODS_LIST_SUCCESS = 'METRIC_DATA_ADMIN_GET_PERIODS_LIST_SUCCESS';
export const METRIC_DATA_ADMIN_GET_PERIODS_LIST_FAILURE = 'METRIC_DATA_ADMIN_GET_PERIODS_LIST_FAILURE';

export const   METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_INIT = 'METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_INIT';
export const   METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_SUCCESS = 'METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_SUCCESS';
export const   METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_FAILURE = 'METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_FAILURE';

export const METRIC_DATA_ADMIN_SET_PERIOD_ID = 'METRIC_DATA_ADMIN_SET_PERIOD_ID';

export const METRIC_DATA_ADMIN_SOFT_RESET = 'METRIC_DATA_ADMIN_SOFT_RESET';
export const METRIC_DATA_ADMIN_RESET = 'METRIC_DATA_ADMIN_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/metricDataAdmin/types.js